/**
 *
 * ProtectedRoute
 *
 */

import React, { FunctionComponent, memo } from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../app/store';

interface IProps {
  path: string;
  component?:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
  exact?: boolean;
  render?: (props: RouteComponentProps<any>) => React.ReactNode;
}

const connector = connect((state: RootState) => ({
  selectedAccount: state.app.selectedAccount,
}));
type PropsFromRedux = ConnectedProps<typeof connector>;

const ProtectedRoute: FunctionComponent<PropsFromRedux & IProps> = ({
  path,
  component,
  exact,
  render,
  selectedAccount,
}) => {
  return selectedAccount ? (
    <Route path={path} exact={exact} component={component} render={render} />
  ) : (
    <Redirect to={`/select-account`} />
  );
};

export default connector(memo(ProtectedRoute));
